var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useRef, } from 'react';
import { withStyles, FormControl, FormControlLabel, FormHelperText, RadioGroup, } from '@material-ui/core';
import MatRadio from '@material-ui/core/Radio';
// onchange example----------------------------------------------------
// export const RadioInputChange = UpdateData => (e, value: string) => {
//     UpdateData({ [e.target.name]: value });
// }
// const----------------------------------------------------
export var EmptyRadioMsg = '請選取其中一個選項。';
// style----------------------------------------------------
export var StyleFormControl = withStyles(function () { return ({
    root: {
    // padding: "5px",
    },
}); })(FormControl);
export var StyleRadioGroup = withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            '& label:hover': {
                background: palette.background.default,
                borderRadius: '10px',
                '& > *': {
                    transition: 'all .3s',
                    color: palette.primary.dark,
                },
            },
        },
    });
})(RadioGroup);
export var StyleFormControlLabel = withStyles({
    root: {
        marginLeft: '0px',
        marginRight: '5px',
    },
    label: {
        fontSize: '1em',
        fontWeight: 'inherit',
    },
})(FormControlLabel);
export var StyleRadio = withStyles(function () { return ({
    root: {
        padding: '3px',
    },
}); })(MatRadio);
export var StyleFormHelperText = withStyles(function () { return ({
    root: {
        margin: '0 14px',
    },
}); })(FormHelperText);
// component----------------------------------------------------
var Radio = function (props) {
    var _a = props.color, color = _a === void 0 ? 'primary' : _a, value = props.value, required = props.required, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.inputRef, inputRef = _c === void 0 ? useRef() : _c, _d = props.verifyBeforeChange, verifyBeforeChange = _d === void 0 ? false : _d, onChange = props.onChange, _e = props.options, options = _e === void 0 ? [] : _e, error = props.error, helperText = props.helperText, _f = props.verifiers, verifiers = _f === void 0 ? [] : _f, _g = props.align, align = _g === void 0 ? 'start' : _g, other = __rest(props, ["color", "value", "required", "disabled", "inputRef", "verifyBeforeChange", "onChange", "options", "error", "helperText", "verifiers", "align"]);
    var _h = useState(''), message = _h[0], setMessage = _h[1];
    var _j = useState(verifyBeforeChange), firstVerify = _j[0], setFirstVerify = _j[1];
    useEffect(function () {
        setFirstVerify(verifyBeforeChange);
    }, [verifyBeforeChange]);
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify)
            return;
        // 驗 HTML validation
        if (inputRef.current) {
            var validationMessage = inputRef.current.getElementsByTagName('input')[0].validationMessage;
            if (validationMessage.length > 0) {
                setMessage(validationMessage);
                return;
            }
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (value && verifiers.length > 0) {
            var veriObj = verifiers.find(function (obj) { return obj.func(value); });
            if (veriObj) {
                setMessage(veriObj.text);
                return;
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [value, options, firstVerify]);
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement(StyleRadioGroup, __assign({ row: true, value: value, onChange: function (e, v) {
                setFirstVerify(true);
                if (onChange) {
                    onChange(e, v);
                }
            }, style: {
                justifyContent: align === 'end' ? 'flex-end' : 'flex-start',
            } }, other), options
            .filter(function (obj) { return obj.show !== false; })
            .map(function (obj, idx) {
            var valueTemp = obj.value, label = obj.label, labelPlacement = obj.labelPlacement;
            var _a = obj.control, control = _a === void 0 ? React.createElement(StyleRadio, { color: color }) : _a;
            // disabled 時，非 value 的選項要設定 disabled，保持 value 有顏色
            if (disabled && valueTemp !== value) {
                control = React.cloneElement(control, { disabled: disabled });
            }
            // 第一個要設定 ref 和 required
            if (idx === 0) {
                control = React.cloneElement(control, {
                    ref: inputRef,
                    required: required,
                });
            }
            return (React.createElement(StyleFormControlLabel, { key: String(valueTemp), value: valueTemp, control: control, label: label, labelPlacement: labelPlacement || align === 'end' ? 'start' : 'end' }));
        })),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
export default Radio;
